import axios from 'axios'
import React, { useMemo } from 'react'
import { ApiClientContext } from '@paintscout/react-quote'
import { getAuthToken } from 'shared/graphql/client'

export function ApiClientProvider({ children }: { children: React.ReactNode }) {
  const client = useMemo(
    () => ({
      get: async <T = any,>(path: string): Promise<T> => {
        const token = await getAuthToken()
        const { data } = await axios.get<T>(`${process.env.PS_API_URL}${path}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        return data
      },
      post: async <T = any,>(path: string, body?: unknown): Promise<T> => {
        const token = await getAuthToken()
        const { data } = await axios.post<T>(`${process.env.PS_API_URL}${path}`, body, {
          headers: { Authorization: `Bearer ${token}` }
        })
        return data
      }
    }),
    []
  )

  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>
}

export default ApiClientProvider
